import { axios } from '@Root/API'

export const getFinanceTuitionDynamicOptions = data => {
	return axios.get('create/financial-support', data)
}
